import React from 'react';
import { connect } from 'react-redux';
import { Tabs, Input, Icon, Table, Button } from 'antd';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Link } from 'react-router-dom';

import Breadcrumbs from '@sp/client/components/Breadcrumbs';
import NavBar from '@sp/client/components/NavBar';

import s from './style.less';
import * as actions from './actions';
import FindPlan from '../ProviderFindPlan';

const { TabPane } = Tabs;
const { Search } = Input;

class ProviderPlans extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      searchValue:
        (this.props.match.params.searchValue &&
          decodeURIComponent(this.props.match.params.searchValue)) ||
        '',
    };
  }

  componentDidMount() {
    this.props.update(this.props.match.params.searchValue);
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.match.params.searchValue !== nextProps.match.params.searchValue
    ) {
      this.props.update(nextProps.match.params.searchValue);
    }
  }

  onSearchChange = e => {
    this.setState({ searchValue: e.target.value });
  };

  onClear = () => {
    this.setState({ searchValue: '' });
    if (this.props.match.params.searchValue) {
      this.props.history.push('/provider/plans');
    }
  };

  search = () => {
    const { searchValue } = this.state;
    const isEmpty = !searchValue && !this.props.match.params.searchValue;

    if (searchValue === this.props.match.params.searchValue || isEmpty) {
      return;
    }

    this.props.history.push(
      `/provider/plans/${encodeURIComponent(searchValue)}`,
    );
  };

  breadcrumbs = [{ name: 'Home', to: '/' }, { name: 'Manage Service Plans' }];

  columns = [
    {
      title: 'Date Sold',
      dataIndex: 'createdAt',
      key: 'date_sold',
      render: date => moment(date).format('DD/MM/YYYY'),
    },
    {
      title: 'Plan Id',
      dataIndex: 'contractNumber',
      key: 'plan_id',
    },
    {
      title: 'Reg',
      dataIndex: 'VRN',
      key: 'VRN',
    },
    {
      title: 'Reg2',
      dataIndex: 'VRN2',
      key: 'VRN2',
    },
    {
      title: 'Customer Surname',
      key: 'customer_surname',
      dataIndex: 'Customer.lastName',
    },
    {
      title: 'Paid',
      key: 'paid',
      render: (text, record) => <span>{record.payed ? 'Yes' : 'No'}</span>,
    },
    {
      title: '',
      key: 'action',
      dataIndex: 'id',
      render: (id, plan) => (
        <span>
          <Link to={`/provider/bookings/create/${id}`}>
            <Button
              type="primary"
              className={s.actionButton}
              disabled={plan.cancelled}
            >
              Book
            </Button>
          </Link>
          <Link to={`/provider/plans/view/${id}`}>
            <Button type="primary" className={s.actionButton}>
              View
            </Button>
          </Link>
          <a
            href={`/reports/plan/${id}`}
            download={`${plan.contractNumber}.pdf`}
          >
            <Button type="primary" className={s.actionButton}>
              Download
            </Button>
          </a>
        </span>
      ),
    },
  ];

  render() {
    const { list } = this.props;
    const { searchValue } = this.state;

    const suffix = searchValue ? (
      <Icon
        key="1"
        type="close-circle"
        className={s.closeIcon}
        onClick={this.onClear}
      />
    ) : null;

    return (
      <NavBar withPadding>
        <Breadcrumbs paths={this.breadcrumbs} />
        <Tabs type="card">
          <TabPane tab="My plans" key="1">
            <div className={s.title}>Service Plans</div>
            <div className={s.subtitle}>
              Search, Manage and Administer your Service Plans
            </div>
            <div className={s.searchContainer}>
              <Search
                placeholder="Enter search text"
                onSearch={this.search}
                suffix={suffix}
                value={searchValue}
                onChange={this.onSearchChange}
                className={s.searchInput}
                enterButton
              />
            </div>
            <Table columns={this.columns} rowKey="id" dataSource={list} />
          </TabPane>
          <TabPane tab="Find a plan" key="2">
            <FindPlan />
          </TabPane>
        </Tabs>
      </NavBar>
    );
  }
}

ProviderPlans.propTypes = {
  list: PropTypes.array.isRequired,
  history: PropTypes.object.isRequired,
  update: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  list: state.plans.list,
});

const mapDispatchToProps = {
  update: actions.update,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProviderPlans);
